var _defs, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurpsuite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m111 119h177v23h-177z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m177 130h45v89h-45z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m111 207h177v89h-177z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 106.02,
    x2: 532.94,
    y1: 267.81,
    y2: 267.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd3535",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7d00",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 43.076v425.87c1.2466-8e-3 2.4896-0.1366 3.7134-0.37205l204.7-39.161c9.6309-1.8384 16.591-10.195 16.589-19.92v-306.66c5e-3 -9.711-6.932-18.063-16.545-19.92l-204.7-39.49c-1.2389-0.23127-2.4967-0.34851-3.7573-0.35028z",
    fill: "url(#a)",
    strokeWidth: 8.0357
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m372.52 109.3v55.827l-68.143 68.727h68.143v56.25h63.482l-63.482 76.762v47.792",
    fill: "none",
    opacity: 0.3,
    stroke: "#000",
    strokeWidth: 24.107
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m372.52 99.304v55.827l-68.143 68.727h68.143v56.25h63.482l-63.482 76.762v47.792",
    fill: "none",
    stroke: "#fdfdfd",
    strokeWidth: 24.107
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 8.0357
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.67 43.054a20.457 20.283 0 0 0-3.7354 0.37205l-204.39 39.49a20.457 20.283 0 0 0-16.545 19.92v306.66a20.457 20.283 0 0 0 16.589 19.92l204.37 39.161a20.457 20.283 0 0 0 4.043 0.37213v-425.87a20.457 20.283 0 0 0-0.32963-0.02186z",
    fill: "#272a34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 399.49v10a20.457 20.283 0 0 0 16.59 19.918l204.36 39.158a20.457 20.283 0 0 0 4.0488 0.375c1.2466-8e-3 2.4793-0.13875 3.7031-0.375l204.71-39.16c9.6309-1.838 16.591-10.192 16.59-19.916v-10c0.00128 9.7245-6.959 18.078-16.59 19.916l-204.71 39.16c-1.2238 0.23625-2.4565 0.36896-3.7031 0.37696a20.457 20.283 0 0 1-4.0488-0.37696l-204.36-39.16a20.457 20.283 0 0 1-16.59-19.916z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.67 43.053a20.457 20.283 0 0 0-3.7344 0.37695l-204.39 39.488a20.457 20.283 0 0 0-16.543 19.916v10a20.457 20.283 0 0 1 16.543-19.916l204.39-39.488a20.457 20.283 0 0 1 3.7344-0.37695 20.457 20.283 0 0 1 0.33008 0.015625c1.2606 0.001768 2.5131 0.13006 3.752 0.36133l204.71 39.488c9.6134 1.8566 16.548 10.205 16.543 19.916v-10c5e-3 -9.7109-6.9296-18.059-16.543-19.916l-204.71-39.488c-1.2389-0.23135-2.4913-0.35956-3.752-0.36133a20.457 20.283 0 0 0-0.33008-0.015625z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.67 43.054a20.457 20.283 0 0 0-3.7354 0.37205l-204.39 39.49a20.457 20.283 0 0 0-16.545 19.92v306.66a20.457 20.283 0 0 0 16.589 19.92l204.37 39.161a20.457 20.283 0 0 0 4.043 0.37213v-425.87a20.457 20.283 0 0 0-0.32963-0.02186z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 399.53v9.9629a20.457 20.283 0 0 0 16.59 19.918l204.36 39.158a20.457 20.283 0 0 0 4.0488 0.375c6.5e-4 -1e-5 0.0013 0 0.00195 0v-9.998h-0.00195a20.457 20.283 0 0 1-4.0488-0.37695l-204.36-39.16a20.457 20.283 0 0 1-16.59-19.879z",
    opacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurpsuite);
export default __webpack_public_path__ + "static/media/burpsuite.1a4e9dd914c723034803109ad101d235.svg";
export { ForwardRef as ReactComponent };